import useLadyService from '../../services/LadyService';
import { useSelector } from 'react-redux';
import { getServicesWords } from '../../stores/slices/userSlice';
import {
	getDisabledFilters,
	getFilterQuery,
} from '@/stores/slices/filterSlice';
import { useMemo, useCallback } from 'react';

export const UrlAllowedWords = [
	'indi',
	'elitelady',
	'pornstar',
	'online',
	'new',
	'vchat',
	'booking',
	'ero',
	'verified',
	'healthy',
	'couple',
	'bdsm',
	'trans',
	'guys',
	'massage',
	'blondes',
	'video',
	'travel',
	'gf',
	'incall',
	'anal',
	'asian',
	'escort',
	'goingout',
	'outcall',
	'girls',
];

export const CityChangeSaveParams = [
	'escort',
	'goingout',
	'outcall',
	'girls',
	'incall',
	'trans',
	'guys',
	'couple',
];

export const STypeOrderArray = ['incall', 'outcall', 'massage', 'escort'];

export const GenderOrderArray = ['female', 'male', 'trans', 'couple'];

export const StatusOrderArray = [
	'elitelady',
	'indi',
	'pornstar',
	'booking',
	'vchat',
	'ero',
	'verified',
	'new',
	'blondes',
	'asian',
	'online',
	'bdsm',
	'anal',
	'health',
	// other agencies, massage, all filters
];

const FilterData = () => {
	const { t, lang, windowWidth } = useLadyService();

	const servicesCategory = useSelector(getServicesWords);
	const disabled_filters = useSelector(getDisabledFilters);

	const disabledSet = useMemo(
		() => new Set(disabled_filters),
		[disabled_filters],
	);
	const query = useSelector(getFilterQuery);
	const querySet = useMemo(() => {
		return new Set(query.map((i) => i.replace('=1', '')));
	}, [query]);

	const parsePlaceQuery = useCallback((queryArray) => {
		const placeItem = queryArray.find((item) => item.startsWith('place='));
		return placeItem ? placeItem.split('place=')[1].split(',') : [];
	}, []);

	const parseGenderQuery = useCallback((queryArray) => {
		const genderItem = queryArray.find((item) =>
			item.startsWith('gender='),
		);
		return genderItem ? genderItem.split('gender=')[1].split(',') : [];
	}, []);

	const parsePenisQuery = useCallback((queryArray) => {
		const penis_item = queryArray.find((item) => item.startsWith('penis='));
		return penis_item ? penis_item.split('penis=')[1].split(',') : [];
	}, []);

	const parseBreastQuery = useCallback((qa) => {
		const breast_item = qa.find((item) => item.startsWith('breast='));
		return breast_item ? breast_item.split('breast=')[1].split(',') : [];
	}, []);

	const parseHairQuery = useCallback((qa) => {
		const hair_item = qa.find((item) => item.startsWith('hair='));
		return hair_item ? hair_item.split('hair=')[1].split(',') : [];
	}, []);

	const parseHairSizeQuery = useCallback((qa) => {
		const hair_len_item = qa.find((item) => item.startsWith('hair_len='));
		return hair_len_item
			? hair_len_item.split('hair_len=')[1].split(',')
			: [];
	}, []);

	const parseHairIntimQuery = useCallback((qa) => {
		const intim_hs_item = qa.find((item) => item.startsWith('intim_hs='));
		return intim_hs_item
			? intim_hs_item.split('intim_hs=')[1].split(',')
			: [];
	}, []);

	const parseEyesQuery = useCallback((qa) => {
		const eyes_item = qa.find((item) => item.startsWith('eyes='));
		return eyes_item ? eyes_item.split('eyes=')[1].split(',') : [];
	}, []);

	const parseLipsQuery = useCallback((qa) => {
		const lips_item = qa.find((item) => item.startsWith('lips='));
		return lips_item ? lips_item.split('lips=')[1].split(',') : [];
	}, []);

	const parseTattosQuery = useCallback((qa) => {
		const tattoo_item = qa.find((item) => item.startsWith('tattoo='));
		return tattoo_item ? tattoo_item.split('tattoo=')[1].split(',') : [];
	}, []);

	const parsePiercingQuery = useCallback((qa) => {
		const piercing_item = qa.find((item) => item.startsWith('piercing='));
		return piercing_item
			? piercing_item.split('piercing=')[1].split(',')
			: [];
	}, []);

	const parseSmokeQuery = useCallback((qa) => {
		const smoke_item = qa.find((item) => item.startsWith('smoke='));
		return smoke_item ? smoke_item.split('smoke=')[1].split(',') : [];
	}, []);

	const parseS_ForQuery = useCallback((qa) => {
		const s_for_item = qa.find((item) => item.startsWith('for='));
		return s_for_item ? s_for_item.split('for=')[1].split(',') : [];
	}, []);

	const parseServicesQuery = useCallback((qa) => {
		const services_item = qa.find((item) => item.startsWith('services='));
		return services_item
			? services_item.split('services=')[1].split(',')
			: [];
	}, []);

	const servicesQuerySet = useMemo(() => {
		return new Set(parseServicesQuery(query));
	}, [query]);

	const s_forQuerySet = useMemo(() => {
		return new Set(parseS_ForQuery(query));
	}, [query]);

	const smokeQuerySet = useMemo(() => {
		return new Set(parseSmokeQuery(query));
	}, [query]);

	const piercingQuerySet = useMemo(() => {
		return new Set(parsePiercingQuery(query));
	}, [query]);

	const tattooQuerySet = useMemo(() => {
		return new Set(parseTattosQuery(query));
	}, [query]);

	const lipsQuerySet = useMemo(() => {
		return new Set(parseLipsQuery(query));
	}, [query]);

	const eyesQuerySet = useMemo(() => {
		return new Set(parseEyesQuery(query));
	}, [query]);

	const intim_hsQuerySet = useMemo(() => {
		return new Set(parseHairIntimQuery(query));
	}, [query]);

	const hair_lenQuerySet = useMemo(() => {
		return new Set(parseHairSizeQuery(query));
	}, [query]);

	const hairQuerySet = useMemo(() => {
		return new Set(parseHairQuery(query));
	}, [query]);

	const genderQueryValues = useMemo(() => {
		return parseGenderQuery(query);
	}, [query]);

	const penisQuerySet = useMemo(() => {
		return new Set(parsePenisQuery(query));
	}, [query]);

	const breastQuerySet = useMemo(() => {
		return new Set(parseBreastQuery(query));
	}, [query, parseBreastQuery]);

	const placeQueryValues = useMemo(() => {
		return parsePlaceQuery(query);
	}, [query]);

	const genderQuerySet = useMemo(() => {
		return new Set(genderQueryValues);
	}, [genderQueryValues]);

	const placeQuerySet = useMemo(() => {
		return new Set(placeQueryValues);
	}, [placeQueryValues]);

	const categorySex = servicesCategory.sex;
	const categoryAdditional = servicesCategory.additional;
	const categoryBdsm = servicesCategory.bdsm;
	const categoryExtreme = servicesCategory.extreme;
	const categoryMassage = servicesCategory.massage;
	const categoryStriptease = servicesCategory.striptease;

	const filterDataObject = useMemo(() => {
		return {
			place: [
				{
					id: 'placeIncall',
					title: t('incall'),
					name: 'place',
					value: 'incall',
					count: 'incall',
					checked: placeQuerySet.has('incall'),
					disabled: disabledSet.has('placeIncall'),
				},
				{
					id: 'placeOutcall',
					title: t('outcall'),
					name: 'place',
					value: 'outcall',
					count: 'outcall',
					checked: placeQuerySet.has('outcall'),
					disabled: disabledSet.has('placeOutcall'),
				},
				{
					id: 'eromassage-1',
					title:
						windowWidth > 767.98 ? t('eromassage') : t('massage'),
					name: 'place',
					count: 'massage',
					value: 'massage',
					checked:
						placeQuerySet.has('massage') || querySet.has('massage'),
					disabled: disabledSet.has('statusMassage'),
				},
				{
					id: 'placeEscort',
					title: t('accompaniment'),
					name: 'place',
					value: 'escort',
					count: 'escort',
					checked: placeQuerySet.has('escort'),
					disabled: disabledSet.has('placeEscort'),
				},
				// {
				// 	id: 'placeSalon',
				// 	title: t('brothel'),
				// 	name: 'place',
				// 	value: 'salon',
				// 	count: 'salon',
				// },
			],

			status: [
				{
					id: 'statusElite',
					title: t('elite'),
					name: 'status',
					value: 'elitelady',
					count: 'elitelady',
					checked: querySet.has('elitelady'),
					disabled: disabledSet.has('statusElite'),
				},
				{
					id: 'statusIndividual',
					title: t('indi'),
					name: 'status',
					value: 'indi',
					count: 'indi',
					checked: querySet.has('indi'),
					disabled: disabledSet.has('statusIndividual'),
				},
				{
					id: 'statusVerification',
					title: t('verified'),
					name: 'status',
					value: 'verified',
					count: 'verified',
					checked: querySet.has('verified'),
					disabled: disabledSet.has('statusVerification'),
				},
				{
					id: 'tagVideochat',
					title: t('videochat'),
					name: 'status',
					value: 'vchat',
					count: 'vchat',
					checked: querySet.has('vchat'),
					disabled: disabledSet.has('tagVideochat'),
				},
				{
					id: 'tagEro',
					title: t('erocontent'),
					name: 'status',
					value: 'ero',
					count: 'ero',
					checked: querySet.has('ero'),
					disabled: disabledSet.has('tagEro'),
				},
				{
					id: 'tagBooking',
					title: t('onlineorder'),
					name: 'status',
					value: 'booking',
					count: 'booking',
					checked: querySet.has('booking'),
					disabled: disabledSet.has('tagBooking'),
				},
				// {
				// 	id: 'statusCouples',
				// 	forDisabled: 'genderCouple',
				// 	title: t('couples'),
				// 	name: 'gender',
				// 	value: 'couple',
				// 	count: 'couple',
				// },

				{
					id: 'statusHealthControl',
					title: t('healthy'),
					name: 'status',
					value: 'healthy',
					count: 'healthy',
					checked: querySet.has('healthy'),
					disabled: disabledSet.has('statusHealthControl'),
				},
				{
					id: 'statusBDSM',
					title: t('bdsm'),
					name: 'status',
					value: 'bdsm',
					count: 'bdsm',
					checked: querySet.has('bdsm'),
					disabled: disabledSet.has('statusBDSM'),
				},
				{
					id: 'statusPornstar',
					title: t('star'),
					name: 'status',
					value: 'pornstar',
					count: 'pornstar',
					checked: querySet.has('pornstar'),
					disabled: disabledSet.has('statusPornstar'),
				},
				{
					id: 'statusFriends',
					title: t('girlfriend'),
					name: 'status',
					value: 'gf',
					count: 'gf',
					checked: querySet.has('gf'),
					disabled: disabledSet.has('statusFriends'),
				},
				// {
				// 	id: 'statustrans',
				// 	forDisabled: 'genderTrans',
				// 	title: t('trans'),
				// 	name: 'gender',
				// 	value: 'trans',
				// 	count: 'trans',
				// },
				{
					id: 'statusOnline',
					title: t('online'),
					name: 'status',
					value: 'online',
					count: 'online',
					checked: querySet.has('online'),
					disabled: disabledSet.has('statusOnline'),
				},
				{
					id: 'statusEscort',
					title: t('accompaniment'),
					name: 'status',
					value: 'escort',
					count: 'escort',
					checked: querySet.has('escort'),
					disabled: disabledSet.has('statusEscort'),
				},
				// {
				// 	id: 'statusGuys',
				// 	forDisabled: 'genderMale',
				// 	title: t('guys'),
				// 	name: 'gender',
				// 	value: 'male',
				// 	count: 'male',
				// },
				{
					id: 'statusNew',
					title: t('newmodels'),
					name: 'status',
					value: 'new',
					count: 'new',
					checked: querySet.has('new'),
					disabled: disabledSet.has('statusNew'),
				},
				{
					id: 'statusTravel',
					title: t('travel'),
					name: 'status',
					value: 'travel',
					count: 'travel',
					checked: querySet.has('travel'),
					disabled: disabledSet.has('statusTravel'),
				},
				{
					id: 'statusVideo',
					title: t('video'),
					name: 'status',
					value: 'video',
					count: 'video',
					checked: querySet.has('video'),
					disabled: disabledSet.has('statusVideo'),
				},
			],

			penis: [
				{
					id: 'penisSmall',
					title: t('penissmall'),
					name: 'penis',
					value: 'small',
					disabled: disabledSet.has('penisSmall'),
					checked: penisQuerySet.has('small'),
				},
				{
					id: 'penisMedium',
					title: t('penismiddle'),
					name: 'penis',
					value: 'medium',
					disabled: disabledSet.has('penisMedium'),
					checked: penisQuerySet.has('medium'),
				},
				{
					id: 'penisBig',
					title: t('penisbig'),
					name: 'penis',
					value: 'big',
					disabled: disabledSet.has('penisBig'),
					checked: penisQuerySet.has('big'),
				},
			],

			breast_size: [
				{
					id: 'breastSmall',
					title: `${t('small')} (0-2)`,
					name: 'breast',
					value: 'small',
					disabled: disabledSet.has('breastSmall'),
					checked: breastQuerySet.has('small'),
				},
				{
					id: 'breastMedium',
					title: `${t('medium')} (3-4)`,
					name: 'breast',
					value: 'medium',
					disabled: disabledSet.has('breastMedium'),
					checked: breastQuerySet.has('medium'),
				},
				{
					id: 'breastBig',
					title: `${t('big')} (5+)`,
					name: 'breast',
					value: 'big',
					disabled: disabledSet.has('breastBig'),
					checked: breastQuerySet.has('big'),
				},
			],

			breast: [
				{
					id: 'breastNature',
					title: t('natural'),
					name: 'appearance',
					value: 'nat',
					checked: querySet.has('breastNature'),
					disabled: disabledSet.has('breastNature'),
				},
				{
					id: 'breastSil',
					title: t('silicone'),
					name: 'appearance',
					value: 'sil',
					checked: querySet.has('breastNature'),
					disabled: disabledSet.has('breastNature'),
				},
			],

			ethnos: [
				{
					id: 'ethnosWhite',
					title: t('white'),
					name: 'ethnos',
					value: 'white',
					count: 'white',
				},
				{
					id: 'ethnosAsian',
					title: t('asian'),
					name: 'ethnos',
					value: 'asian',
					count: 'asian',
				},
				{
					id: 'ethnosAfrican',
					title: t('african'),
					name: 'ethnos',
					value: 'african',
					count: 'african',
				},
				{
					id: 'ethnosArabic',
					title: t('arabic'),
					name: 'ethnos',
					value: 'arab',
					count: 'arabic',
				},
				{
					id: 'ethnosIndian',
					title: t('indian'),
					name: 'ethnos',
					value: 'indian',
					count: 'indian',
				},
				{
					id: 'ethnosMulatto',
					title: t('tanned'),
					name: 'ethnos',
					value: 'mulatto',
					count: 'mulatto',
				},
				{
					id: 'ethnosMixed',
					title: t('mixed'),
					name: 'ethnos',
					value: 'mixed',
					count: 'mixed',
				},
				{
					id: 'ethnosLatin',
					title: t('latin'),
					name: 'ethnos',
					value: 'latin',
					count: 'latin',
				},
			],

			hair: [
				{
					id: 'hairBlond',
					title: t('blond'),
					name: 'hair',
					value: 'blond',
					count: 'blond',
					path: 'blondes',
					disabled: disabledSet.has('hairBlond'),
					checked: hairQuerySet.has('blond'),
				},
				{
					id: 'hairBrown',
					title: t('brown'),
					name: 'hair',
					value: 'brown',
					count: 'brown',
					disabled: disabledSet.has('hairBrown'),
					checked: hairQuerySet.has('brown'),
				},
				{
					id: 'hairBrunette',
					title: t('brunette'),
					name: 'hair',
					value: 'brunette',
					count: 'brunette',
					disabled: disabledSet.has('hairBrunette'),
					checked: hairQuerySet.has('brunette'),
				},
				{
					id: 'hairRed',
					title: t('ginger'),
					name: 'hair',
					value: 'red',
					count: 'red',
					disabled: disabledSet.has('hairRed'),
					checked: hairQuerySet.has('red'),
				},
			],

			hair_size: [
				{
					id: 'hairSizeShort',
					title: t('short'),
					name: 'hair_len',
					value: 'short',
					count: 'short',
					disabled: disabledSet.has('hairSizeShort'),
					checked: hair_lenQuerySet.has('short'),
				},
				{
					id: 'hairSizeMedium',
					title: t('mediuma'),
					name: 'hair_len',
					value: 'medium',
					count: 'medium',
					disabled: disabledSet.has('hairSizeMedium'),
					checked: hair_lenQuerySet.has('medium'),
				},
				{
					id: 'hairSizeLong',
					title: t('long'),
					name: 'hair_len',
					value: 'long',
					count: 'long',
					disabled: disabledSet.has('hairSizeLong'),
					checked: hair_lenQuerySet.has('long'),
				},
			],

			hair_intim: [
				{
					id: 'hairIntimShaved',
					title: t('shaved'),
					name: 'intim_hs',
					value: 'shaved',
					disabled: disabledSet.has('hairIntimShaved'),
					checked: intim_hsQuerySet.has('shaved'),
				},
				{
					id: 'hairIntimHaircut',
					title: t('cut'),
					name: 'intim_hs',
					value: 'haircut',
					disabled: disabledSet.has('hairIntimHaircut'),
					checked: intim_hsQuerySet.has('haircut'),
				},
				{
					id: 'hairIntimNature',
					title: t('natural'),
					name: 'intim_hs',
					value: 'natural',
					disabled: disabledSet.has('hairIntimNature'),
					checked: intim_hsQuerySet.has('natural'),
				},
			],

			eyes_type: [
				{
					id: 'eyeTypeLenses',
					title: t('lenses'),
					name: 'appearance',
					value: 'lens',
					disabled: disabledSet.has('eyeTypeLenses'),
					checked: querySet.has('lens'),
				},
				{
					id: 'eyeTypeGlasses',
					title: t('glasses'),
					name: 'appearance',
					value: 'glass',
					disabled: disabledSet.has('eyeTypeGlasses'),
					checked: querySet.has('glass'),
				},
			],

			eyes: [
				{
					id: 'eyeColorBlue',
					title: t('blue'),
					name: 'eyes',
					value: 'blue',
					disabled: disabledSet.has('eyeColorBlue'),
					checked: eyesQuerySet.has('blue'),
				},
				{
					id: 'eyeColorGreen',
					title: t('green'),
					name: 'eyes',
					value: 'green',
					disabled: disabledSet.has('eyeColorGreen'),
					checked: eyesQuerySet.has('green'),
				},
				{
					id: 'eyeColorBrown',
					title: t('brownyies'),
					name: 'eyes',
					value: 'brown',
					disabled: disabledSet.has('eyeColorBrown'),
					checked: eyesQuerySet.has('brown'),
				},
				{
					id: 'eyeColorGray',
					title: t('gray'),
					name: 'eyes',
					value: 'gray',
					disabled: disabledSet.has('eyeColorGray'),
					checked: eyesQuerySet.has('gray'),
				},
			],

			lips: [
				{
					id: 'specialLipsNatural',
					title: t('natural'),
					name: 'lips',
					value: 'natural',
					disabled: disabledSet.has('specialLipsNatural'),
					checked: lipsQuerySet.has('natural'),
				},
				{
					id: 'specialLipsPumped',
					title: t('enhanced'),
					name: 'lips',
					value: 'pumped_up',
					disabled: disabledSet.has('specialLipsPumped'),
					checked: lipsQuerySet.has('pumped_up'),
				},
			],

			tattoo: [
				{
					id: 'specialTattooNo',
					title: t('none'),
					name: 'tattoo',
					value: 'no',
					disabled: disabledSet.has('specialTattooNo'),
					checked: tattooQuerySet.has('no'),
				},
				{
					id: 'specialTattooFew',
					title: t('few'),
					name: 'tattoo',
					value: 'few',
					disabled: disabledSet.has('specialTattooFew'),
					checked: tattooQuerySet.has('few'),
				},
				{
					id: 'specialTattooMany',
					title: t('many'),
					name: 'tattoo',
					value: 'many',
					disabled: disabledSet.has('specialTattooMany'),
					checked: tattooQuerySet.has('many'),
				},
			],

			piercing: [
				{
					id: 'specialPiercingNo',
					title: t('none'),
					name: 'piercing',
					value: 'no',
					disabled: disabledSet.has('specialPiercingNo'),
					checked: piercingQuerySet.has('no'),
				},
				{
					id: 'specialPiercingFew',
					title: t('few'),
					name: 'piercing',
					value: 'few',
					disabled: disabledSet.has('specialPiercingFew'),
					checked: piercingQuerySet.has('few'),
				},
				{
					id: 'specialPiercingMany',
					title: t('many'),
					name: 'piercing',
					value: 'many',
					disabled: disabledSet.has('specialPiercingMany'),
					checked: piercingQuerySet.has('many'),
				},
			],

			smoke: [
				{
					id: 'specialSmokeNo',
					title: t('none'),
					name: 'smoking',
					value: 'no',
					disabled: disabledSet.has('specialSmokeNo'),
					checked: smokeQuerySet.has('no'),
				},
				{
					id: 'specialSmokeSometimes',
					title: t('rarely'),
					name: 'smoking',
					value: 'sometimes',
					disabled: disabledSet.has('specialSmokeSometimes'),
					checked: smokeQuerySet.has('sometimes'),
				},
				{
					id: 'specialSmokeOften',
					title: t('often'),
					name: 'smoking',
					value: 'regularly',
					disabled: disabledSet.has('specialSmokeOften'),
					checked: smokeQuerySet.has('regularly'),
				},
			],

			gender: [
				{
					id: 'genderFemale',
					title: t('girls'),
					name: 'gender',
					value: 'female',
					count: 'female',
					checked: genderQuerySet.has('female'),
					disabled: disabledSet.has('genderFemale'),
				},
				{
					id: 'genderMale',
					title: t('guys'),
					name: 'gender',
					value: 'male',
					count: 'male',
					checked: genderQuerySet.has('male'),
					disabled: disabledSet.has('genderMale'),
				},
				{
					id: 'genderTrans',
					title: t('trans'),
					name: 'gender',
					value: 'trans',
					count: 'trans',
					checked: genderQuerySet.has('trans'),
					disabled: disabledSet.has('genderTrans'),
				},
				{
					id: 'genderCouple',
					title: t('couples'),
					name: 'gender',
					value: 'couple',
					count: 'couple',
					checked: genderQuerySet.has('couple'),
					disabled: disabledSet.has('genderCouple'),
				},
			],

			sex: [
				{
					id: 'sexStraight',
					title: t('hetero'),
					name: 'sex',
					value: 'straight',
					button_checkboxes: true,
					count: 'straight',
					disabled: disabledSet.has('sexStraight'),
				},
				{
					id: 'sexHomosexual',
					title: t('homo'),
					name: 'sex',
					value: 'homosexual',
					button_checkboxes: true,
					count: 'homosexual',
					disabled: disabledSet.has('sexHomosexual'),
				},
				{
					id: 'sexLesbian',
					title: t('lesbi'),
					name: 'sex',
					value: 'lesbian',
					button_checkboxes: true,
					count: 'lesbian',
					disabled: disabledSet.has('sexLesbian'),
				},
				{
					id: 'sexBisexual',
					title: t('bi'),
					name: 'sex',
					value: 'bisexual',
					button_checkboxes: true,
					count: 'bisexual',
					disabled: disabledSet.has('sexBisexual'),
				},
			],

			services: {
				for: [
					{
						id: 'forMen',
						title: t('men'),
						name: 'for',
						value: 'men',
						checked: s_forQuerySet.has('men'),
						disabled: disabledSet.has('forMan'),
					},
					{
						id: 'forWomen',
						title: t('women'),
						name: 'for',
						value: 'women',
						checked: s_forQuerySet.has('women'),
						disabled: disabledSet.has('forWomen'),
					},
					{
						id: 'forCouples',
						title: t('couples'),
						name: 'for',
						value: 'couples',
						checked: s_forQuerySet.has('couples'),
						disabled: disabledSet.has('forCouples'),
					},
					{
						id: 'forGroups',
						title: t('groups'),
						name: 'for',
						value: 'groups',
						checked: s_forQuerySet.has('groups'),
						disabled: disabledSet.has('forGroups'),
					},
				],

				sex: [
					{
						id: 'servicesSexClassic',
						title: categorySex?.services[1]?.slug,
						name: 'services',
						value: '1',
						disabled: disabledSet.has('servicesSexClassic'),
					},
					{
						id: 'servicesSexBlowjobDeep',
						title: categorySex?.services[8]?.slug,
						name: 'services',
						value: '8',
						disabled: disabledSet.has('servicesSexBlowjobDeep'),
					},
					{
						id: 'servicesSexAnal',
						title: categorySex?.services[2]?.slug,
						name: 'services',
						value: '2',
						disabled: disabledSet.has('servicesSexAnal'),
						checked: servicesQuerySet.has('2'),
					},
					{
						id: 'servicesSexLickingBalls',
						title: categorySex?.services[9]?.slug,
						name: 'services',
						value: '9',
						disabled: disabledSet.has('servicesSexLickingBalls'),
					},
					{
						id: 'servicesSexSixtyNine',
						title: categorySex?.services[3]?.slug,
						name: 'services',
						value: '3',
						disabled: disabledSet.has('servicesSexSixtyNine'),
					},
					{
						id: 'servicesSexCunnilingus',
						title: categorySex?.services[10]?.slug,
						name: 'services',
						value: '10',
						disabled: disabledSet.has('servicesSexCunnilingus'),
					},
					{
						id: 'servicesSexKissing',
						title: categorySex?.services[4]?.slug,
						name: 'services',
						value: '4',
						disabled: disabledSet.has('servicesSexKissing'),
					},
					{
						id: 'servicesSexToys',
						title: categorySex?.services[11]?.slug,
						name: 'services',
						value: '11',
						disabled: disabledSet.has('servicesSexToys'),
					},
					{
						id: 'servicesSexMasturbation',
						title: categorySex?.services[5]?.slug,
						name: 'services',
						value: '5',
						disabled: disabledSet.has('servicesSexMasturbation'),
					},
					{
						id: 'servicesSexFinishOnBreast',
						title: categorySex?.services[12]?.slug,
						name: 'services',
						value: '12',
						disabled: disabledSet.has('servicesSexFinishOnBreast'),
					},
					{
						id: 'servicesSexBlowjobInCondom',
						title: categorySex?.services[6]?.slug,
						name: 'services',
						value: '6',
						disabled: disabledSet.has('servicesSexBlowjobInCondom'),
					},
					{
						id: 'servicesSexFinishOnFace',
						title: categorySex?.services[13]?.slug,
						name: 'services',
						value: '13',
						disabled: disabledSet.has('servicesSexFinishOnFace'),
					},
					{
						id: 'servicesSexBlowjob',
						title: categorySex?.services[7]?.slug,
						name: 'services',
						value: '7',
						disabled: disabledSet.has('servicesSexBlowjob'),
					},
					{
						id: 'servicesSexFinishInMouth',
						title: categorySex?.services[14]?.slug,
						name: 'services',
						value: '14',
						disabled: disabledSet.has('servicesSexFinishInMouth'),
					},
				],

				sex_mobile: [
					{
						id: 'servicesSexClassic',
						title: categorySex?.services[1]?.slug,
						name: 'services',
						value: '1',
						disabled: disabledSet.has('servicesSexClassic'),
					},
					{
						id: 'servicesSexAnal',
						title: categorySex?.services[2]?.slug,
						name: 'services',
						value: '2',
						disabled: disabledSet.has('servicesSexAnal'),
					},
					{
						id: 'servicesSexBlowjob',
						title: categorySex?.services[6]?.slug,
						name: 'services',
						value: 'blowjob',
						disabled: disabledSet.has('servicesSexBlowjob'),
					},
					{
						id: 'servicesSexBlowjobDeep',
						title: categorySex?.services[8]?.slug,
						name: 'services',
						value: 'blowjob_deep',
						disabled: disabledSet.has('servicesSexBlowjobDeep'),
					},
					{
						id: 'servicesSexToys',
						title: categorySex?.services[11]?.slug,
						name: 'services',
						value: 'sex_toys',
						disabled: disabledSet.has('servicesSexToys'),
					},
					{
						id: 'servicesSexFinishOnBreast',
						title: categorySex?.services[12]?.slug,
						name: 'services',
						value: 'finish_on_breast',
						disabled: disabledSet.has('servicesSexFinishOnBreast'),
					},
					{
						id: 'servicesSexFinishOnFace',
						title: categorySex?.services[13]?.slug,
						name: 'services',
						value: 'finish_on_face',
						disabled: disabledSet.has('servicesSexFinishOnFace'),
					},
					{
						id: 'servicesSexFinishInMouth',
						title: categorySex?.services[14]?.slug,
						name: 'services',
						value: 'finish_in_mouth',
						disabled: disabledSet.has('servicesSexFinishInMouth'),
					},
					{
						id: 'servicesSexBlowjobInCondom',
						title: categorySex?.services[6]?.slug,
						name: 'services',
						value: 'blowjob_in_condom',
						disabled: disabledSet.has('servicesSexBlowjobInCondom'),
					},
					{
						id: 'servicesSexCunnilingus',
						title: categorySex?.services[10]?.slug,
						name: 'services',
						value: 'cunnilingus',
						disabled: disabledSet.has('servicesSexCunnilingus'),
					},
					{
						id: 'servicesSexKissing',
						title: categorySex?.services[4]?.slug,
						name: 'services',
						value: 'kissing',
						disabled: disabledSet.has('servicesSexKissing'),
					},
					{
						id: 'servicesSexSixtyNine',
						title: categorySex?.services[3]?.slug,
						name: 'services',
						value: 'sixty_nine',
						disabled: disabledSet.has('servicesSexSixtyNine'),
					},
				],

				strip: [
					{
						id: 'servicesStrip1',
						title: categoryStriptease?.services[15]?.slug,
						name: 'services',
						value: '15',
						disabled: disabledSet.has('servicesStrip1'),
					},
					{
						id: 'servicesStrip2',
						title: categoryStriptease?.services[17]?.slug,
						name: 'services',
						value: '17',
						disabled: disabledSet.has('servicesStrip2'),
					},
					{
						id: 'servicesStrip3',
						title: categoryStriptease?.services[16]?.slug,
						name: 'services',
						value: '16',
						disabled: disabledSet.has('servicesStrip3'),
					},
					{
						id: 'servicesStrip4',
						title: categoryStriptease?.services[18]?.slug,
						name: 'services',
						value: '18',
						disabled: disabledSet.has('servicesStrip4'),
					},
				],

				massage: [
					{
						id: 'servicesMassage1',
						title: categoryMassage?.services[19]?.slug,
						name: 'services',
						value: '19',
						disabled: disabledSet.has('servicesMassage1'),
					},
					{
						id: 'servicesMassage2',
						title: categoryMassage?.services[23]?.slug,
						name: 'services',
						value: '23',
						disabled: disabledSet.has('servicesMassage2'),
					},
					{
						id: 'servicesMassage3',
						title: categoryMassage?.services[20]?.slug,
						name: 'services',
						value: '20',
						disabled: disabledSet.has('servicesMassage3'),
					},
					{
						id: 'servicesMassage4',
						title: categoryMassage?.services[24]?.slug,
						name: 'services',
						value: '24',
						disabled: disabledSet.has('servicesMassage4'),
					},
					{
						id: 'servicesMassage5',
						title: categoryMassage?.services[21]?.slug,
						name: 'services',
						value: '21',
						disabled: disabledSet.has('servicesMassage5'),
					},
					{
						id: 'servicesMassage6',
						title: categoryMassage?.services[25]?.slug,
						name: 'services',
						value: '25',
						disabled: disabledSet.has('servicesMassage6'),
					},
					{
						id: 'servicesMassage7',
						title: categoryMassage?.services[22]?.slug,
						name: 'services',
						value: '22',
						disabled: disabledSet.has('servicesMassage7'),
					},
					{
						id: 'servicesMassage8',
						title: categoryMassage?.services[27]?.slug,
						name: 'services',
						value: '27',
						disabled: disabledSet.has('servicesMassage8'),
					},
					{
						id: 'servicesMassage9',
						title: categoryMassage?.services[26]?.slug,
						name: 'services',
						value: '26',
						disabled: disabledSet.has('servicesMassage9'),
					},
					{
						id: 'servicesMassage10',
						title: categoryMassage?.services[59]?.slug,
						name: 'services',
						value: '59',
						disabled: disabledSet.has('servicesMassage10'),
					},
					{
						id: 'servicesMassage11',
						title: categoryMassage?.services[60]?.slug,
						name: 'services',
						value: '60',
						disabled: disabledSet.has('servicesMassage11'),
					},

					{
						id: 'servicesMassage12',
						title: categoryMassage?.services[61]?.slug,
						name: 'services',
						value: '61',
						disabled: disabledSet.has('servicesMassage12'),
					},
				],

				bdsm: [
					{
						id: 'servicesBdsm1',
						title: categoryBdsm?.services[28]?.slug,
						name: 'services',
						value: '28',
						disabled: disabledSet.has('servicesBdsm1'),
					},
					{
						id: 'servicesBdsm3',
						title: categoryBdsm?.services[29]?.slug,
						name: 'services',
						value: '29',
						disabled: disabledSet.has('servicesBdsm3'),
					},
					{
						id: 'servicesBdsm5',
						title: categoryBdsm?.services[30]?.slug,
						name: 'services',
						value: '30',
						disabled: disabledSet.has('servicesBdsm5'),
					},
					{
						id: 'servicesBdsm12',
						title: categoryBdsm?.services[35]?.slug,
						name: 'services',
						value: '35',
						disabled: disabledSet.has('servicesBdsm12'),
					},
					{
						id: 'servicesBdsm36',
						title: categoryBdsm?.services[36]?.slug,
						name: 'services',
						value: '36',
						disabled: disabledSet.has('servicesBdsm36'),
					},
				],

				extrim: [
					{
						id: 'servicesBdsm14',
						title: categoryExtreme?.services[42]?.slug,
						name: 'services',
						value: '42',
						disabled: disabledSet.has('servicesBdsm14'),
					},
					{
						id: 'servicesBdsm2',
						title: categoryExtreme?.services[39]?.slug,
						name: 'services',
						value: '39',
						disabled: disabledSet.has('servicesBdsm2'),
					},
					{
						id: 'servicesBdsm15',
						title: categoryExtreme?.services[43]?.slug,
						name: 'services',
						value: '43',
						disabled: disabledSet.has('servicesBdsm15'),
					},
					{
						id: 'servicesBdsm4',
						title: categoryExtreme?.services[40]?.slug,
						name: 'services',
						value: '40',
						disabled: disabledSet.has('servicesBdsm4'),
					},
					{
						id: 'servicesBdsm6',
						title: categoryExtreme?.services[41]?.slug,
						name: 'services',
						value: '41',
						disabled: disabledSet.has('servicesBdsm6'),
					},
					{
						id: 'servicesBdsm13',
						title: categoryExtreme?.services[45]?.slug,
						name: 'services',
						value: '45',
						disabled: disabledSet.has('servicesBdsm13'),
					},
					{
						id: 'servicesBdsm16',
						title: categoryExtreme?.services[46]?.slug,
						name: 'services',
						value: '46',
						disabled: disabledSet.has('servicesBdsm16'),
					},
					{
						id: 'servicesBdsm19',
						title: categoryExtreme?.services[38]?.slug,
						name: 'services',
						value: '38',
						disabled: disabledSet.has('servicesBdsm19'),
					},
					{
						id: 'servicesBdsm20',
						title: categoryExtreme?.services[47]?.slug,
						name: 'services',
						value: '47',
						disabled: disabledSet.has('servicesBdsm20'),
					},
				],

				extra: [
					{
						id: 'servicesExtra1',
						title: categoryAdditional?.services[48]?.slug,
						name: 'services',
						value: '48',
						disabled: disabledSet.has('servicesExtra1'),
					},
					{
						id: 'servicesExtra2',
						title: categoryAdditional?.services[49]?.slug,
						name: 'services',
						value: '49',
						disabled: disabledSet.has('servicesExtra2'),
					},
					{
						id: 'servicesExtra3',
						title: categoryAdditional?.services[50]?.slug,
						name: 'services',
						value: '50',
						disabled: disabledSet.has('servicesExtra3'),
					},
					{
						id: 'servicesExtra4',
						title: categoryAdditional?.services[51]?.slug,
						name: 'services',
						value: '51',
						disabled: disabledSet.has('servicesExtra4'),
					},
					{
						id: 'servicesExtra5',
						title: categoryAdditional?.services[52]?.slug,
						name: 'services',
						value: '52',
						disabled: disabledSet.has('servicesExtra5'),
					},
					{
						id: 'servicesExtra6',
						title: categoryAdditional?.services[53]?.slug,
						name: 'services',
						value: '53',
						disabled: disabledSet.has('servicesExtra6'),
					},
					{
						id: 'servicesExtra7',
						title: categoryAdditional?.services[54]?.slug,
						name: 'services',
						value: '54',
						disabled: disabledSet.has('servicesExtra7'),
					},
					{
						id: 'servicesExtra8',
						title: categoryAdditional?.services[55]?.slug,
						name: 'services',
						value: '55',
						disabled: disabledSet.has('servicesExtra8'),
					},
					{
						id: 'servicesExtra9',
						title: categoryAdditional?.services[56]?.slug,
						name: 'services',
						value: '56',
						disabled: disabledSet.has('servicesExtra9'),
					},
					{
						id: 'servicesExtra10',
						title: categoryAdditional?.services[57]?.slug,
						name: 'services',
						value: '57',
						disabled: disabledSet.has('servicesExtra10'),
					},
					{
						id: 'servicesExtra11',
						title: categoryAdditional?.services[58]?.slug,
						name: 'services',
						value: '58',
						disabled: disabledSet.has('servicesExtra11'),
					},
					{
						id: 'servicesExtra13',
						title: categoryAdditional?.services[32]?.slug,
						name: 'services',
						value: '32',
						disabled: disabledSet.has('servicesExtra13'),
					},
					{
						id: 'servicesExtra14',
						title: categoryAdditional?.services[37]?.slug,
						name: 'services',
						value: '37',
						disabled: disabledSet.has('servicesExtra14'),
					},
					{
						id: 'servicesExtra15',
						title: categoryAdditional?.services[34]?.slug,
						name: 'services',
						value: '34',
						disabled: disabledSet.has('servicesExtra15'),
					},
				],
			},

			min_time: [
				{
					id: 'min_time15',
					title: `15 ${t('min')}`,
					name: 'min_time',
					value: '15',
					count: '15',
					button_checkboxes: true,
				},
				{
					id: 'minTarifs30',
					title: `30 ${t('min')}`,
					name: 'min_time',
					value: '30',
					count: '30',
					button_checkboxes: true,
				},
				{
					id: 'minTarifs60',
					title: t('hour'),
					name: 'min_time',
					value: '60',
					count: '60',
					button_checkboxes: true,
				},
			],

			last_visit: [
				{
					id: 'lastVisitToday',
					title: t('today'),
					name: 'last_visit',
					value: 'visitToday',
					count: 'today',
					radio: true,
				},
				{
					id: 'lastVisitYesterday',
					title: t('yesterday'),
					name: 'last_visit',
					value: 'visitSubDay',
					count: 'subDay',
					radio: true,
				},
				{
					id: 'lastVisitOnWeek',
					title: t('thisweek'),
					name: 'last_visit',
					value: 'visitSubWeek',
					count: 'subWeek',
					radio: true,
				},
				{
					id: 'lastVisitInMonth',
					title: t('thismonth'),
					name: 'last_visit',
					value: 'visitSubMonth',
					count: 'subMonth',
					radio: true,
				},
			],

			radius: [
				{
					id: 'radius1',
					title: `1 ${t('km')}`,
					name: 'radius',
					value: '1',
					count: '1',
					radio: true,
				},
				{
					id: 'radius3',
					title: `3 ${t('km')}`,
					name: 'radius',
					value: '3',
					count: '3',
					radio: true,
				},
				{
					id: 'radius5',
					title: `5 ${t('km')}`,
					name: 'radius',
					value: '5',
					count: '5',
					radio: true,
				},
				{
					id: 'radius10',
					title: `10 ${t('km')}`,
					name: 'radius',
					value: '10',
					count: '10',
					radio: true,
				},
				{
					id: 'radius20Plus',
					title: `20+ ${t('km')}`,
					name: 'radius',
					value: '20',
					count: '20',
					radio: true,
				},
			],
		};
	}, [servicesCategory, lang, disabledSet, querySet, windowWidth]);
	return filterDataObject;
};

export default FilterData;
